module.exports = [
	{
		path: 'annuaire-acces',
		name: 'Annuaire des accès',
		component: () => import('@/pages/tools/annuaire_acces/annuaire_acces.vue'),
		meta: {
			label: 'Annuaire des accès',
			icon: 'web',
			description: ``
		}
	},
	{
		path: 'suifa-of',
		name: 'Suifa OF',
		component: () => import('@/pages/tools/suifa_of/suifa_of.vue'),
		meta: {
			label: 'OF Suifa',
			icon: 'web',
			description: ``
		}
	},
	{
		path: 'calculDebit',
		name: 'Calcul débit',
		component: () => import('@/pages/tools/calcul_debit/calculDebit.vue'),
		meta: {
			label: 'Calcul Débit',
			icon: 'lens',
			description: `Calculatrice de débit (poids / débit / durée)`
		}
	},
	{
		path: 'doviMetaQc',
		name: 'DOVI Meta QC',
		component: () => import('@/pages/tools/dovi_meta_qc/doviMetaQc.vue'),
		meta: {
			label: 'DOVI Meta QC',
			icon: 'lens',
			description: `Parseur et validateur de métadonnées Dolby Vision`
		}
	},
	{
		path: 'doviMetaQc_old',
		name: 'DOVI Meta QC [OLD]',
		component: () => import('@/pages/tools/dovi_meta_qc/doviMetaQc_old.vue'),
		meta: {
			label: 'DOVI Meta QC [OLD]',
			icon: 'lens',
			description: `Parseur et validateur de métadonnées Dolby Vision`
		}
	},
	{
		path: 'singularities',
		name: 'Singularities',
		component: () => import('@/pages/tools/singularities/singularities.vue'),
		meta: {
			label: 'EZTXML Singularities',
			icon: 'device_hub',
			description: `Parseur EztXml pour singularities client`
		}
	},
	{
		path: 'tccalc',
		name: 'TC Calc',
		component: () => import('@/pages/tools/timecodes/tcCalc.vue'),
		meta: {
			label: 'TC Calc',
			icon: 'lens',
			description: `Calculatrice de timecodes (Offset et Conversion de fréquence)`
		}
	},
	{
		path: 'tcstart',
		name: 'TC start',
		component: () => import('@/pages/tools/tc_start/tcSTart.vue'),
		meta: {
			label: 'TC Start',
			icon: 'timer',
			description: `Information de timecode start d'un asset`
		}
	},
	{
		path: 'xlsToItunesXml',
		name: 'XLS to Itunes XML',
		component: () => import('@/pages/tools/xls_to_itunes_xml/xlsToItunesXml.vue'),
		meta: {
			label: 'XLS to iTunes XML',
			icon: 'web',
			description: `Convertisseur de template XLS de metadata Itunes vers XML Itunes light`
		}
	},
	{
		path: 'cml_editor',
		name: 'CML editor',
		component: () => import('@/pages/tools/cml_editor/cml_editor.vue'),
		meta: {
			label: 'Editeur CML Vantage (En développement)',
			icon: 'web',
			description: `Editeur de CML pour Vantage`
		}
	},
	{
		path: '/ezexport',
		name: 'EZ Export',
		component: () => import('@/pages/tools/ezexport/ezexport.vue'),
		meta: {
			label: 'EZ Export (Beta)',
			icon: 'title',
			description: `Outil d'exportation pour les équipes de sous-titrage (en développement)`
		}
	},
	{
		path: '/orange_eval',
		name: 'Orange Eval',
		component: () => import('@/pages/tools/orange_eval/orange_eval.vue'),
		meta: {
			label: 'Orange Eval',
			icon: 'title',
			description: `Outil d'évaluation pour les demandes Orange `
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/routes_tools.js